import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  DrawerHeader,
  DrawerBody,
  DrawerFooter,
  Typography
} from '@one-thd/sui-atomic-components';

const CARD_CLASS = 'sui-mb-3';

export const ChoosingTheRightTool = ({ onBack, onClose }) => {
  return (
    <>
      <DrawerHeader
        title="Choosing the Right Tool"
        onBack={onBack}
        onClose={onClose}
      />
      <DrawerBody>
        <div className={CARD_CLASS}>
          <Typography variant="body-base" weight="bold">Projects</Typography>
          <Typography variant="body-xs" weight="bold" height="tight">
            Your hub to organize and track progress for your jobs in one place
          </Typography>
          <div className="sui-mt-2">
            <Typography variant="body-xs" weight="bold">
              Best For:
            </Typography>
          </div>
          <ul className="sui-list-disc sui-pl-5 sui-mt-1">
            <li><Typography variant="body-xs" height="tight">Build out a job from start to finish</Typography></li>
            <li><Typography variant="body-xs" height="tight">Manage multiple phases or trades</Typography></li>
            <li><Typography variant="body-xs" height="tight">Return later to add more materials</Typography></li>
          </ul>
          <div className="sui-mt-2">
            <Typography variant="body-xs">
              <Typography component="span" variant="body-xs" weight="bold">Use Projects when: </Typography>
              Tracking and managing the whole job from a central hub
            </Typography>
          </div>
        </div>

        <div className={CARD_CLASS}>
          <Typography variant="body-base" weight="bold">Lists</Typography>
          <Typography variant="body-xs" weight="bold" height="tight">
            Build reusable templates and custom catalogs for frequently purchased materials
          </Typography>
          <div className="sui-mt-2">
            <Typography variant="body-xs" weight="bold">
              Best For:
            </Typography>
          </div>
          <ul className="sui-list-disc sui-pl-5 sui-mt-1">
            <li><Typography variant="body-xs" height="tight">Create your own custom catalog of materials to use</Typography></li>
            <li><Typography variant="body-xs" height="tight">Organize by item category</Typography></li>
            <li><Typography variant="body-xs" height="tight">Build a library of common bundles</Typography></li>
          </ul>
          <div className="sui-mt-2">
            <Typography variant="body-xs">
              <Typography component="span" variant="body-xs" weight="bold">Use Lists when: </Typography>
              You want to organize material templates to reuse across jobs
            </Typography>
          </div>
        </div>

        <div className={CARD_CLASS}>
          <Typography variant="body-base" weight="bold">Quotes</Typography>
          <Typography variant="body-xs" weight="bold" height="tight">
            Lock in prices before you buy
          </Typography>
          <div className="sui-mt-2">
            <Typography variant="body-xs" weight="bold">
              Best For:
            </Typography>
          </div>
          <ul className="sui-list-disc sui-pl-5 sui-mt-1">
            <li><Typography variant="body-xs" height="tight">Confirming costs with customers</Typography></li>
            <li><Typography variant="body-xs" height="tight">Protecting pricing for future milestones</Typography></li>
            <li><Typography variant="body-xs" height="tight">Getting approvals before purchasing</Typography></li>
            <li><Typography variant="body-xs" height="tight">Jobs where timing affects material costs</Typography></li>
          </ul>
          <div className="sui-mt-2">
            <Typography variant="body-xs">
              <Typography component="span" variant="body-xs" weight="bold">Use Quotes when: </Typography>
              You need guaranteed pricing or want to present estimated costs to a client.
            </Typography>
          </div>
        </div>
      </DrawerBody>
      <DrawerFooter>
        <Button
          fullWidth
          variant="secondary"
          onClick={onClose}
        >
          Cancel
        </Button>
      </DrawerFooter>
    </>
  );
};

ChoosingTheRightTool.propTypes = {
  onBack: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};

ChoosingTheRightTool.displayName = 'ChoosingTheRightTool';
